import { displayError } from "../../utils/messageToast";
import { SetupRC } from "../../apis/apisRCByAuthorization";

export const getTabId = async (
  tabIdForm: string,
  authorization: string,
  ambient: string,
  setTabName: React.Dispatch<React.SetStateAction<string>>,
  signOut: () => void
) => {
  try {
    if (tabIdForm === "") {
      return;
    }
    const apiClient = SetupRC(authorization);
    const response = await apiClient.get(
      `/get-tab?tabId=${tabIdForm}&ambient=${ambient}`
    );
    setTabName(response.data.name);
    return response.data;
  } catch (error: any) {
    // displayError("Tabulação não encontrada!");
    return;
  }
};
